import React from "react";

export default function Section13() {
  const processSteps = [
    {
      title: "Planning",
      description:
        "We define clear business goals, product structure, and technical needs to build a focused development roadmap.",
    },
    {
      title: "Design",
      description:
        "Create clean, conversion-focused layouts that simplify navigation and encourage confident purchasing decisions.",
    },
    {
      title: " Development",
      description:
        "Build your Shopify store with stable functionality, structured setup, and reliable performance.",
    },
    {
      title: "Testing",
      description:
        "We carefully test speed, responsiveness, and checkout flow to ensure smooth user experience.",
    },
    {
      title: " Launch & Ongoing Support",
      description:
        "We manage launch smoothly and continue supporting your store as it grows and evolves.",
    },
    
  ];

  return (
    <div className="w-full Section13">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Our Development Workflow
        </h2>
        <p className="text-[#373737] text-sm md:text-base leading-[22px] mb-8">
        </p>

        <div className="boxes flex flex-wrap justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] w-[85%] mx-auto">
          {processSteps.map((step, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
                }`}
            >
              <h3 className="md:text-[25px] text-[20px] font-bold leading-[30px] mb-3">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm leading-[22px] font-open">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
